import { render, staticRenderFns } from "./addGames.vue?vue&type=template&id=34219bdb&"
import script from "./addGames.vue?vue&type=script&lang=js&"
export * from "./addGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34219bdb')) {
      api.createRecord('34219bdb', component.options)
    } else {
      api.reload('34219bdb', component.options)
    }
    module.hot.accept("./addGames.vue?vue&type=template&id=34219bdb&", function () {
      api.rerender('34219bdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/list/components/addGames.vue"
export default component.exports